import { memo } from 'react';

import { PROFILE_ICONS } from '@/features/profile/constants/icons';
import {
  ProgressCircleIndicator,
  type ProgressCircleIndicatorProps,
} from '@/shared/components/progressCircleIndicator';

export interface ProfileGameplayIndicatorProps extends Omit<
  ProgressCircleIndicatorProps,
  'icon' | 'progress'
> {
  progress: number;
  showLabel?: boolean;
}

export const ProfileGameplayIndicator = memo(function ProfileGameplayIndicator({
  progress,
  showLabel,
  ...props
}: ProfileGameplayIndicatorProps) {
  const GameplayIcon = PROFILE_ICONS.gameplay;

  const indicator = (
    <ProgressCircleIndicator
      progress={progress}
      icon={<GameplayIcon className="size-7" />}
      {...props}
    />
  );

  if (!showLabel) {
    return indicator;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex w-14 flex-col items-end">
        <span className="text-cold-100 text-sm font-bold">Playstyle</span>
        <span className="text-cold-300 text-xs font-medium">
          {Math.round(progress)}%
        </span>
      </div>
      {indicator}
    </div>
  );
});
